import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=1754af03&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=1754af03&scoped=true&lang=scss&"
import style1 from "./TaskList.vue?vue&type=style&index=1&id=1754af03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754af03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1754af03')) {
      api.createRecord('1754af03', component.options)
    } else {
      api.reload('1754af03', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=1754af03&scoped=true&", function () {
      api.rerender('1754af03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/TaskList.vue"
export default component.exports